// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"App_layoutWrapper__5Z3zv"};